import { Collapse } from 'bootstrap'
import '../scss/styles.scss'
import Rails from '@rails/ujs'

import '@fortawesome/fontawesome-free/css/all.css'

import Search from '../Search.svelte'

const app = []

document.addEventListener('DOMContentLoaded', function () {
  const elements = document.getElementsByClassName('search-svelte')
  for (var i = 0; i < elements.length; i++) {
    elements[i].innerHTML = ''
    const search = new Search({ target: elements[i] })
    app.push(search)
  }
  // https://github.com/rails/rails/blob/main/actionview/app/assets/javascripts/rails-ujs.js
  if (window._rails_loaded != true) {
    Rails.start()
  }
})

export default app
